<template>
  <fragment>
    <div class="energy-wrap" :style="{'background-image':'url('+ swiperOption.numBgc +')'}">
      <span :style="styleOption('bg').fontStyle">{{swiperOption.leftInput}}</span>
      <span :style="styleOption('bg').countStyle">{{remainingEnergy}}</span>
      <span :style="styleOption('bg').fontStyle">{{swiperOption.rightInput}}</span>
    </div>
    <div class="swiper-wrap swiper-no-swiping" :style="{'background-image':'url('+ swiperOption.swiperBgc +')'}">
      <swiper :auto-update="true" :auto-destroy="true" :delete-instance-on-destroy="true"
        :cleanup-styles-on-destroy="true" ref="mySwiper" v-if="prizeInfoList.length>0" :options="swiperOptions">
        <swiper-slide :key="index" v-for="(item,index) in prizeInfoList">
          <p :style="styleOption('swiper').fontStyle">恭喜{{item.userPhone}}抽到{{item.prizeName | formatStr}}</p>
        </swiper-slide>
      </swiper>
    </div>
    <div class="wantgrid-wrap" :style="{'background-image':'url('+ gridBgImgSrc + ')'}">
      <ul class="grid-content" :style="{'background-image':'url('+ gridContent.bg + ')'}">
        <li :key="index" :class="['grid-item', currentIndex==index ? 'current' : '']"
          v-for="(item, index) in prizeList">
          <img v-if="index < 6" class="grid-img" v-show="currentIndex==index" :src="gridContent.list[index].img" alt />
          <img v-if="index < 6 && activePrizeIndex==index" ref="activeGridImg"
            :class="['grid-active', 'active-' + index]" :src="gridContent.list[index].active"
            @load="girdActiveImgLoad($event)" alt />
        </li>
      </ul>
    </div>
    <div class="grid-btn-wrap" :style="{'background-image':'url('+ gridBtnImgSrc +')'}">
      <button class="btn" :disabled="btnDisabled" @click="startLottery"></button>
    </div>
    <div class="rule-wrap">
      <div class="header">
        <img :src="ruleOption.ruleHeaderImg" alt />
      </div>
      <div class="content">
        <div class="hot-area">
          <div v-for="(item,index) in 3" @click="changeRule(index)" :class="current==index?'current':''"
            :current="current" :key="item"></div>
        </div>
        <img :src="ruleOption.ruleLeftImg" v-show="current==0" alt />
        <img :src="ruleOption.ruleMiddleImg" v-show="current==1" alt />
        <img :src="ruleOption.ruleRightImg" v-show="current==2" alt />
      </div>
      <div class="footer" @click="handleClick('rule')">
        <img :src="ruleOption.ruleBottomImg" alt />
      </div>
    </div>
    <div class="reward-wrap" v-if="this.activityStatus>2">
      <div class="header">
        <img :src="awardOption.awardHeaderImg" alt />
      </div>
      <div :class="recordList.length <=0 ? 'content' : 'content active'"
        :style="{'background-image':'url('+ gridContent.prizeListbg + ')'}" ref="content" @scroll="handleRecordScroll">
        <template v-if="recordList.length<=0">
          <img :src="awardOption.awardMiddleImg" alt />
        </template>
        <template v-else>
          <img :src="item.prizeImage" @click="checkPrize(item)" alt :key="index" v-for="(item,index) in recordList" />
        </template>
      </div>
      <div class="footer">
        <img :src="awardOption.ruleBottomImg" alt />
      </div>
    </div>
    <Cmask :showMask="showMask" :opacity="maskOpacity">
      <div class="content-wrap" v-if="modalType">
        <!-- 第一次进入且有引导图 显示引导图 -->
        <div class="guide-wrap" v-if="beFirst&&modalType=='guide'">
          <img :src="swiperOption.guideImg" alt />
        </div>
        <!-- 数值不足时候显示图片 -->
        <div class="countError-wrap" v-else-if="modalType=='countError'">
          <img :src="gridOption.countEnable" alt />
        </div>
        <!-- 奖品弹窗 //Integer	奖品类型 0.谢谢参与	1怪兽充点券 2外部三方兑换码 3实物表单奖品 4 无兑换码礼包[告知类奖品] -->

        <div class="prize-wrap" v-else-if="modalType=='prize'" @click="handleCopy">
          <div
            :class="['prize-content', animTransition ? 'rotateTransitionReverse' :'', !animTransitionReverse ? 'prize-content-reverse' : '']"
            :style="{'background-image':'url('+ modelBgc +')'}">
            <fragment v-if="prize.prizeType==0"></fragment>
            <fragment v-else-if="prize.prizeType==1"></fragment>
            <!-- 点击复制第三方券码 -->
            <span v-else-if="prize.prizeType==2" class="ticket-code" :style="prizeFontStyle">{{ticketCode}}</span>
            <div v-else-if="prize.prizeType==3">
              <div class="form">
                <fragment :key="index" v-for="(item,index) in prizeFormItems">
                  <div v-if="item.paramName=='name'" class="form-row">
                    <img :src="lightIcon" class="form-icon" alt />
                    <label :style="prizeFontStyle" for class="form-label">收货人：</label>
                    <input :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="15" class="form-input"
                      type="text" placeholder="请填写收货人姓名" v-model="userInfo.name" />
                    <!-- :placeholder="item.tips" -->
                  </div>
                  <div v-else-if="item.paramName=='phone'" class="form-row">
                    <img :src="lightIcon" class="form-icon" alt />
                    <label :style="prizeFontStyle" for class="form-label">联系方式：</label>
                    <input :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="11" class="form-input"
                      type="tel" placeholder="请填写收货人手机号" v-model="userInfo.phone" />
                  </div>
                  <div v-else-if="item.paramName=='address'" class="form-row address-row">
                    <div class="address-label">
                      <img :src="lightIcon" class="form-icon" alt />
                      <label :style="prizeFontStyle" for class="form-label">收件地址：</label>
                    </div>
                    <textarea :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="500"
                      class="form-textarea" rows="3" placeholder="请填写街道、楼牌号等" v-model="userInfo.address"
                      contenteditable="true"></textarea>
                  </div>
                  <div v-else-if="item.paramName=='remark'" class="form-row">
                    <label :style="prizeFontStyle" for class="form-label">备注：</label>
                    <input :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="500"
                      class="form-input" type="text" :placeholder="item.tips" v-model="userInfo.remark" />
                  </div>
                  <div v-else-if="item.paramName=='other'" class="form-row">
                    <label :style="prizeFontStyle" for class="form-label">其他：</label>
                    <textarea :style="prizeBorderStyle" :disabled="userInfoBtnStatus===1" maxlength="500"
                      class="form-textarea" rows="3" :placeholder="item.tips" v-model="userInfo.other"
                      contenteditable="true"></textarea>
                  </div>
                </fragment>
              </div>
              <img :src="submitBtn" @click="addLotteryAddress" v-if="userInfoBtnStatus===0" class="btn" />
              <img :src="submittedBtn" v-if="userInfoBtnStatus===1" class="btn" />
            </div>
            <!-- TODO：点击复制提示文字 tipMessage -->
            <div class="prize-area" @click="handleClick('prize')" v-else-if="prize.prizeType==4"></div>
            <div class="line">
              <span v-for="item in 5" :key="item"></span>
              <img class="close-icon" src="./../../../assets/imgs/close.png" @click="closeDialog" alt />
            </div>
          </div>
        </div>

        <div class="line" v-if="modalType!='prize'">
          <span v-for="item in 5" :key="item"></span>
          <img class="close-icon" src="./../../../assets/imgs/close.png" @click="closeDialog" alt />
        </div>
      </div>

      <div class="content-wrap" v-if="showActiveGif">
        <div class="active-gif-wrap">
          <img :class="['active-gif', animTransition ? 'rotateTransition' : '']" ref="activeGif"
            @load="loadPrizeGifImg($event)" :src="gridContent.list[activePrizeIndex].gif" alt />
        </div>
      </div>

    </Cmask>
  </fragment>
</template>

<script>
import { isMiniApplets, isMiNiProgram } from "@/utils/browser";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "Grid",
  props: {
    info: {
      type: Object,
      required: true
    },
    activityId: {
      type: String,
      required: true
    },
    openId: {
      type: String,
      required: true
    },
    activityStatus: {
      //活动状态 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束"),
      type: Number,
      required: true
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    styleOption() {
      //活动数值或中奖轮播的样式设置
      return str => {
        let fontStyle = {};
        let countStyle = {};
        let swiperOption = this.info.props.imgList.swiperOption;
        if (str == "swiper") {
          fontStyle = {
            "font-size": `${swiperOption.awardFontfontSize / 2}px`,
            color: swiperOption.awardFontColor,
            "font-style": swiperOption.awardFontFontStyle.includes("italic")
              ? "italic"
              : "",
            "font-weight": swiperOption.awardFontFontStyle.includes("bold")
              ? "bold"
              : "",
            "text-stroke": `1px ${swiperOption.awardFontBoxShadow}`
          };
        } else {
          fontStyle = {
            "font-size": `${swiperOption.fontfontSize / 2}px`,
            color: swiperOption.fontColor,
            "font-style": swiperOption.fontFontStyle.includes("italic")
              ? "italic"
              : "",
            "font-weight": swiperOption.fontFontStyle.includes("bold")
              ? "bold"
              : "",
            "text-stroke": `1px ${swiperOption.fontBoxShadow}`
          };
          countStyle = {
            "font-size": `${swiperOption.countfontSize / 2}px`,
            color: swiperOption.countColor,
            "font-style": swiperOption.countFontStyle.includes("italic")
              ? "italic"
              : "",
            "font-weight": swiperOption.countFontStyle.includes("bold")
              ? "bold"
              : "",
            "text-stroke": `1px ${swiperOption.countBoxShadow}`
          };
        }
        return { fontStyle, countStyle };
      };
    },
    gridBtnImgSrc() {
      // 抽奖按钮背景
      let bgSrc = "";
      let { lotteryingBtn, unlotteryBtn } = this.info.props.imgList.gridOption;
      if (this.isLottery) {
        bgSrc = lotteryingBtn;
      } else {
        bgSrc = unlotteryBtn;
      }
      return bgSrc;
    },
    gridBgImgSrc() {
      // 抽奖九宫格背景
      let {
        isSpecStatus,
        lotterying,
        unlottery,
        speciOffbgc
      } = this.info.props.imgList.gridOption;
      let bgSrc = "";
      if (isSpecStatus) {
        if (this.isLottery) {
          bgSrc = lotterying;
        } else {
          bgSrc = unlottery;
        }
      } else {
        bgSrc = speciOffbgc;
      }
      return bgSrc;
    }
  },
  created() { },
  data() {
    return {
      remainingEnergy: 0, //能量
      remainingOpportunities: "", //抽奖次数
      prizeList: [],
      prizeInfoList: [],
      isLottery: false, //是否在抽奖
      // 我的奖品配置
      awardOption: {},
      // 九宫格配置
      gridOption: {},
      // 轮播配置
      swiperOption: {},
      // // 规则配置
      ruleOption: {},
      beFirst: false, //是否是第一次打开
      recordList: [], //中奖记录
      prize: {
        prizeType: 3
      }, //奖品信息
      // form动态配置
      prizeFormItems: [],
      activityGuide: "", //活动引导图
      btnDisabled: false,
      currentIndex: -1, //起点位置
      count: 6, //共多少个位置
      timer: 0, //每次转动定时器
      speed: 200, //初始转动速度
      times: 0, // 转动次数
      cycle: 8, //转动基数：至少需要转动多少次再进入抽奖环节
      prizeColumn: 4, //中奖位置
      showMask: false, //弹框是否开启
      userInfoBtnStatus: undefined,
      modalType: "", //弹出框的类型 //guide(引导图) countError(数值不足) prize(奖品)
      current: 0, //规则图片所在位置
      ticketCode: "", //第三方券码
      tipMessage: "", // 告知型奖品提示文字
      swiperOptions: {
        notNextTick: true,
        direction: "vertical", //控制滚动的方向
        autoplay: {
          disableOnInteraction: false,
          delay: 2000 //这里需要注意，如果想每2秒去自动切换，直接autoplay:2000是失效的，
        },
        loop: true,
        loopedSlides: 0,
        autoHeight: true,
        // height:39,
        disableOnInteraction: false
      },
      modelBgc: "",
      userInfo: {
        //填表型填写的用户信息
        phone: "",
        name: "",
        address: "",
        remark: "",
        other: ""
      },
      hasMore: true, // 是否有更多数据
      pageIndex: 1, // 分页页数
      pageSize: 5, // 分页条数
      submitBtn: "", // 未提交按钮
      submittedBtn: "", // 已提交按钮
      prizeFontStyle: {},
      prizeBorderStyle: {},
      clickForwardConfig: {}, // prizeType==4的时候跳转链接
      gridContent: { // 抽奖内容区域：针对旺旺活动
        temp: 'https://static.enmonster.com/1342026184757948416',
        bg: 'https://static.enmonster.com/1342004981842391040',
        list: [
          {
            img: 'https://static.enmonster.com/1342008434320814080',
            active: 'https://static.enmonster.com/1342010085811236864',
            temp: 'https://static.enmonster.com/1342010044241489920',
            gif: 'https://static.enmonster.com/1342009999668621312'
          },
          {
            img: 'https://static.enmonster.com/1342008612033474560',
            active: 'https://static.enmonster.com/1342010225569640448',
            temp: 'https://static.enmonster.com/1342010176311734272',
            gif: 'https://static.enmonster.com/1342010135702482944'
          },
          {
            img: 'https://static.enmonster.com/1342008650998558720',
            active: 'https://static.enmonster.com/1342010369962749952',
            temp: 'https://static.enmonster.com/1342010325972889600',
            gif: 'https://static.enmonster.com/1342010274701717504'
          },
          {
            img: 'https://static.enmonster.com/1342054459546873856',
            active: 'https://static.enmonster.com/1342010510841032704',
            temp: 'https://static.enmonster.com/1342010464846295040',
            gif: 'https://static.enmonster.com/1342010414598533120'
          },
          {
            img: 'https://static.enmonster.com/1342008720611422208',
            active: 'https://static.enmonster.com/1342010859509329920',
            temp: 'https://static.enmonster.com/1342010816471576576',
            gif: 'https://static.enmonster.com/1342010771475083264'
          },
          {
            img: 'https://static.enmonster.com/1342008753754812416',
            active: 'https://static.enmonster.com/1342010998617616384',
            temp: 'https://static.enmonster.com/1342010956842348544',
            gif: 'https://static.enmonster.com/1342010910629507072'
          }
        ],
        prizeListbg: 'https://static.enmonster.com/1346747253200859136'
      },
      activePrizeIndex: -1, // 中奖索引
      showActiveGif: false, // 展示中奖gif
      animTransition: false, // 抽奖翻牌子动画
      animTransitionReverse: false, // 是否处于抽奖动画过程中
      loadActiveGif: false, // 加载完奖品动画
      animObj: {
        destX: 33.1 + 618 / 4,
        destY: 71.875 + 780 / 4,
        area: (618 / 2) * (780 / 2)
      }, // 过渡动画属性集合
      lightIcon: 'https://static.enmonster.com/1343844112822251520',
      maskOpacity: 0.6
    };
  },
  watch: {
    // "prize.prizeType": {
    //   handler(n, o) {
    //     if (n == 0) {
    //       this.modelBgc = "http://file02.16sucai.com/d/file/2014/0520/0f2ba3175baa30d9d8705e689d34efcc.jpg";
    //     } else if (n == 1) {
    //       this.modelBgc = "http://file02.16sucai.com/d/file/2014/0520/0f2ba3175baa30d9d8705e689d34efcc.jpg";
    //     } else if (n == 2) {
    //       this.modelBgc = "http://gss0.baidu.com/94o3dSag_xI4khGko9WTAnF6hhy/zhidao/pic/item/eaf81a4c510fd9f95f48a24b212dd42a2834a4b1.jpg";
    //     } else if (n == 3) {
    //       this.modelBgc = "http://gss0.baidu.com/94o3dSag_xI4khGko9WTAnF6hhy/zhidao/pic/item/eaf81a4c510fd9f95f48a24b212dd42a2834a4b1.jpg";
    //     } else if (n == 4) {
    //       this.modelBgc = "http://gss0.baidu.com/94o3dSag_xI4khGko9WTAnF6hhy/zhidao/pic/item/eaf81a4c510fd9f95f48a24b212dd42a2834a4b1.jpg";
    //     }
    //   },
    //   deep: true
    // }
  },
  mounted() {
    this.formatData();
    this.getLotteryDetail();
    this.getRecordList();
    this.getLotteryUserList();
  },
  filters: {
    formatStr(str = []) {
      return str.length <= 4 ? str : str.substr(0, 4) + '...'
    }
  },
  methods: {
    //初始化数据
    formatData() {
      this.awardOption = this.info.props.imgList.awardOption;
      this.gridOption = this.info.props.imgList.gridOption;
      this.ruleOption = this.info.props.imgList.ruleOption;
      this.swiperOption = this.info.props.imgList.swiperOption;
      // this.isLottery = this.gridOption.isSpecStatus;
      this.modalType = "guide";
    },
    // 开始抽奖
    startLottery() {
      if (this.btnDisabled) {
        return;
      }
      try {
        TDAPP.onEvent(`九宫格${this.info.key}`, "抽奖按钮");
      } catch (e) {
        console.log("打点失败", e);
      }
      this.btnDisabled = true; //设置按钮禁用
      this.handleLottery();
    },
    // 用户点击抽奖
    handleLottery() {
      let params = {
        activityId: this.activityId,
        openId: this.openId
      };
      this.$fetch(
        { url: "/ehs/activity/user/lottery", method: "post" },
        params
      ).then(res => {

        if (res.success) {
          this.prizeColumn = Number(res.model.prize.column) > 5 ? 4 : Number(res.model.prize.column); //获取奖品位置

          this.prize = res.model.prize; //获取奖品
          this.speed = 200; //设置初始速度
          this.isLottery = true; //设置是否在抽奖状态
          // this.remainingOpportunities = this.remainingOpportunities - 1; //点击之后就让次数减一
          this.currentIndex = -1; //设置抽奖开始位置
          this.activePrizeIndex = -1; //设置抽奖动画开始位置
          this.startRoll();
          // resolve();
        } else {
          this.btnDisabled = false; //设置按钮禁用
          if (res.errorCode == "CLA100118") {
            this.modalType = "countError";
            this.showMask = true;
            return;
          } else if (res.errorCode == "CLA100007") {
            // 活动未开始
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: this.gridOption.actiUnstartTips,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
            return;
          } else if (res.errorCode == "CLA100117") {
            // 活动已经结束提示
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: this.gridOption.actiFinishedTips,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
            return;
          }
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: res.errorMessage,
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        }
      }).catch(_ => {
        this.btnDisabled = false; //设置按钮禁用
      });
    },
    // 开始转动
    startRoll() {
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
      // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
      if (
        this.times > this.cycle + 10 &&
        this.prizeColumn == this.currentIndex
      ) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        this.times = 0;
        this.pageIndex = 1;
        this.recordList = [];
        setTimeout(() => {
          this.isLottery = false;
          this.btnDisabled = false;
          this.getLotteryDetail();
          this.getRecordList()
          if (this.prize.prizeType != 0) {
            this.getLotteryAddress(() => {
              this.activePrizeIndex = this.prizeColumn
              this.triggerPrizeAnim()
            });
          } else {
            this.showMask = true;
            this.modelBgc = this.prize.winPopupImage;
            this.activePrizeIndex = this.prizeColumn
            this.triggerPrizeAnim()
          }
        }, 500);
      } else {
        if (this.times < this.cycle) {
          this.speed -= 10; // 加快转动速度
        } else if (this.times === this.cycle) {
          // 随机获得一个中奖位置
          // const index = parseInt(Math.random() * 10, 0) || 0
          // this.prize = index
          // if (this.prize > 7) {
          //   this.prize = 7
          // }
          console.log(`中奖位置${this.prize}`);
        } else if (
          this.times > this.cycle + 20 &&
          ((this.prizeColumn === 0 && this.currentIndex === 5) ||
            this.prizeColumn === this.currentIndex + 1)
        ) {
          this.speed += 110;
        } else {
          this.speed += 20;
        }

        if (this.speed < 40) {
          this.speed = 40;
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },

    // 每一次转动
    oneRoll() {
      let index = this.currentIndex; // 当前转动到哪个位置
      const count = this.count; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.currentIndex = index;
    },
    // 切换规则图片
    changeRule(index) {
      this.current = index;
    },
    // 获取抽奖页面详情
    getLotteryDetail() {
      return new Promise(resolve => {
        let params = {
          activityId: this.activityId,
          openId: this.openId
        };
        this.$fetch(
          { url: "/ehs/activity/user/lottery/page/detail", method: "post" },
          params
        ).then(res => {
          if (res.success) {
            this.remainingEnergy = res.model.remainingEnergy; //能量
            // this.recordList = res.model.recordList || []; //中奖记录
            this.remainingOpportunities = res.model.remainingOpportunities; //抽奖次数
            this.prizeList = res.model.prizeList || []; //奖品数组
            this.beFirst = res.model.beFirst; //是否是第一次打开
            if (this.beFirst) {
              this.showMask = this.swiperOption.isGuideImg;
            }
            // resolve(res.model);
          } else {
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: res.errorMessage,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
          }
        });
      });
    },
    // 分页获取奖品信息
    getRecordList() {
      let params = {
        openId: this.openId,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        activityId: this.activityId
      };
      this.$fetch(
        { url: "/ehs/activity/user/win/prize/page", method: "post" },
        params
      )
        .then(res => {
          if (res.success) {
            if (res.totalPage == this.pageIndex) {
              this.hasMore = false;
            } else {
              this.hasMore = true;
              this.pageIndex++;
            }
            this.recordList = [...this.recordList, ...res.model];
          } else {
            this.$toast({
              styles: {
                maskColor: "rgba(0,0,0,0)",
                background: "rgba(0,0,0,0.4)",
                messageColor: "#fff"
              },
              content: res.errorMessage,
              duration: 2000
            }).then(() => {
              console.log("finish");
            });
          }
        })
        .catch(_ => { });
    },
    // 奖品区域滚动加载更多
    handleRecordScroll() {
      let scrollTop = this.$refs["content"].scrollTop;
      let clientHeight = this.$refs["content"].clientHeight;
      let scrollHeight = this.$refs["content"].scrollHeight;
      if (scrollTop + clientHeight + 30 >= scrollHeight && this.hasMore) {
        this.hasMore = false;
        this.throttle(this.getRecordList, 2000)();
      }
    },
    // 节流器
    throttle(fn, interval = 500) {
      let timer = null;
      let firstTime = true;

      return function () {
        let args = arguments;
        if (firstTime) {
          // 第一次加载
          fn.apply(this, args);
          return (firstTime = false);
        }
        if (timer) {
          // 定时器正在执行中，跳过
          return;
        }
        timer = setTimeout(() => {
          // clearTimeout(timer);
          timer = null;
          fn.apply(this, args);
        }, interval);
      };
    },
    handleCopy() {
      if (2 == this.prize.prizeType) {
        this.copyMsg(this.ticketCode);
      }
    },
    // 复制文字
    copyMsg(msg) {
      this.$copyText(msg).then(
        e => {
          this.copySuccess();
        },
        err => {
          this.copyError();
        }
      );
    },
    // 复制成功的提示操作
    copySuccess() {
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff"
        },
        content: "复制成功",
        duration: 2000
      }).then(() => {
        console.log("finish");
      });
    },
    // 复制失败的提示操作
    copyError() {
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff"
        },
        content: "复制出错",
        duration: 2000
      }).then(() => {
        console.log("finish");
      });
    },
    // 收获地址信息查看
    getLotteryAddress(cb) {
      let params = {
        activityId: this.activityId,
        openId: this.openId,
        recordId: this.prize.recordId
      };
      this.$fetch(
        { url: "/ehs/activity/user/address/getAddress", method: "post" },
        params
      ).then(res => {
        if (res.success) {
          let result = res.model;
          if (result.entityPrizeFormConfig) {
            this.prizeFormItems =
              result.entityPrizeFormConfig.prizeFormItems || [];
            this.submitBtn = result.entityPrizeFormConfig.submitBtn;
            this.submittedBtn = result.entityPrizeFormConfig.submittedBtn;
          }
          this.userInfoBtnStatus = result.status;
          this.modelBgc = result.winPopupImage;
          this.showMask = true;
          cb && cb()
          if (result.prizeType == 3) {
            let titleInputBoxCssConfig =
              result.entityPrizeFormConfig.titleInputBoxCssConfig;
            this.userInfo = {
              name: res.model.name,
              phone: res.model.phone,
              address: res.model.address,
              remark: res.model.remark,
              other: res.model.other
            };
            this.prizeFontStyle = {
              "font-size": `${titleInputBoxCssConfig.size / 2}px`,
              color: titleInputBoxCssConfig.color,
              "font-style": titleInputBoxCssConfig.style.includes("italic")
                ? "italic"
                : "",
              "font-weight": titleInputBoxCssConfig.style.includes("bold")
                ? "bold"
                : ""
              // "text-stroke": `1px ${titleInputBoxCssConfig.outline}`
            };
            this.prizeBorderStyle = {
              ...this.prizeFontStyle,
              "border-color": titleInputBoxCssConfig.color
            };
          } else if (result.prizeType == 2) {
            this.ticketCode = result.prizeCode;
            let couponCssConfig = result.couponCssConfig;
            this.prizeFontStyle = {
              "font-size": `${couponCssConfig.size / 2}px`,
              color: couponCssConfig.color,
              "font-style": couponCssConfig.style.includes("italic")
                ? "italic"
                : "",
              "font-weight": couponCssConfig.style.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${couponCssConfig.outline}`
            };
          } else if (result.prizeType == 4) {
            this.clickForwardConfig = result.clickForwardConfig;
          }
        } else {
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: res.errorMessage,
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        }
      });
    },
    // 填写收货地址信息
    addLotteryAddress() {
      // if (this.userInfo.name.length > 15) {
      //   this.$alert.message("姓名不能超过15字", "提示");
      //   return;
      // }
      // if (!/1\d{10}/.test(this.userInfo.phone)) {
      //   this.$alert.message("手机号不符合规则", "提示");
      //   return;
      // }
      for (let i = 0; i < this.prizeFormItems.length; i++) {
        let item = this.prizeFormItems[i];
        switch (item.paramName) {
          case "name":
            if (!this.trim(this.userInfo.name)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【收货人】不能为空。",
                duration: 3000
              });
              return;
            }
            break;
          case "phone":
            if (!this.trim(this.userInfo.phone)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【联系方式】不能为空。",
                duration: 3000
              });
              return;
            } else if (!/1\d{10}/.test(this.userInfo.phone)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【联系方式】格式错误。",
                duration: 3000
              });
              return;
            }
            break;
          case "address":
            if (!this.trim(this.userInfo.address)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【收件地址】不能为空。",
                duration: 3000
              });
              return;
            }
            break;
          case "remark":
            if (!this.trim(this.userInfo.remark)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【备注】不能为空。",
                duration: 3000
              });
              return;
            }
            break;
          case "other":
            if (!this.trim(this.userInfo.other)) {
              this.$toast({
                styles: {
                  maskColor: "rgba(0,0,0,0)",
                  background: "rgba(0,0,0,0.4)",
                  messageColor: "#fff"
                },
                content: "【其他】不能为空。",
                duration: 3000
              });
              return;
            }
            break;
        }
      }

      let params = {
        activityId: this.activityId,
        openId: this.openId,
        recordId: this.prize.recordId,
        ...this.userInfo
      };
      this.$fetch(
        { url: "/ehs/activity/user/address/add", method: "post" },
        params
      ).then(res => {
        if (res.success) {
          console.log({ grid: res.model });
          this.showMask = false;
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: "提交成功",
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        } else {
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: res.errorMessage,
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        }
      });
    },
    // 查询中奖用户列表
    getLotteryUserList() {
      let params = {
        activityId: this.activityId,
        openId: this.openId
      };
      this.$fetch(
        { url: "/ehs/activity/user/hit/list", method: "post" },
        params
      ).then(res => {
        if (res.success) {
          this.prizeInfoList = res.model || [];
        } else {
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff"
            },
            content: res.errorMessage,
            duration: 2000
          }).then(() => {
            console.log("finish");
          });
        }
      });
    },
    close(val) {
      this.showMask = val;
    },
    closeDialog() {
      this.prizeFontStyle = {};
      this.prizeBorderStyle = {};
      this.showMask = false;
      this.currentIndex = -1;
      this.prizeColumn = 4;
      this.activePrizeIndex = -1;
      this.animTransition = false;
      this.animTransitionReverse = false;
      this.showActiveGif = false; // 展示中奖gif
      this.loadActiveGif = false;
    },
    // 查看我的奖品
    checkPrize(item) {
      console.log(item);
      //Integer	奖品类型	1怪兽充点券 2外部兑换码 3实物奖品 4 无兑换码礼包
      this.prize = item;
      this.getLotteryAddress();
      // this.showMask = true;
      this.modalType = "prize";
    },
    // 规则区域尾图点击跳转
    handleClick(str) {
      if (str == "rule") {
        try {
          TDAPP.onEvent(`九宫格${this.info.key}`, "点击规则尾图");
        } catch (e) {
          console.log("打点失败", e);
        }
        this.$emit("handleGridClick", this.ruleOption);
      } else if (str == "prize") {
        if (this.clickForwardConfig.jumpType == 6) {
          let isMiniApp = isMiniApplets();
          if (isMiniApp === "wechat") {
            this.copyMsg(
              this.clickForwardConfig.wxCopyContent ||
              this.prize.clickForwardConfig.wxCopyContent
            );
          } else {
            this.copyMsg(
              this.clickForwardConfig.aliCopyContent ||
              this.prize.clickForwardConfig.aliCopyContent
            );
          }
        } else {
          this.$emit("handleGridClick", this.clickForwardConfig);
        }
      }
    },
    loadPrizeGifImg(e) { // 监听奖品gif加载完毕
      this.loadActiveGif = true
      let activeGif = this.$refs.activeGif
      activeGif.addEventListener('transitionend', () => {
        setTimeout(() => {
          this.animTransition = true
          this.modalType = "prize";
          this.animTransitionReverse = true
          setTimeout(() => {
            this.showActiveGif = false
            this.animTransitionReverse = false
            setTimeout(() => {
              this.animTransition = false
            }, 1000)
          }, 1000)
        }, 1000)
      })

    },
    triggerPrizeAnim() { // 触发奖品动画
      this.modalType = ''
      this.showActiveGif = true
      this.maskOpacity = 0
    },
    girdActiveImgLoad(e) { // 激活图片加载完成
      let target = e.target
      let timer = setInterval(() => {
        let loadActiveGif = this.loadActiveGif

        if (loadActiveGif) {
          clearInterval(timer)
          this.maskOpacity = 0.6
          let activeImgRect = target.getBoundingClientRect()

          let activeGridImg = this.$refs.activeGridImg[0]

          let activeImgPos = {
            x: activeImgRect.left + activeImgRect.width / 2,
            y: activeImgRect.top + activeImgRect.height / 2,
          }

          let deltaX = (this.animObj.destX - activeImgPos.x)
          let deltaY = (this.animObj.destY - activeImgPos.y)
          let ratio = Math.pow(Math.sqrt(this.animObj.area / (activeImgRect.width * activeImgRect.height)), 1 / 5)

          activeGridImg.style.transform = `translate(${deltaX / 5}px,${deltaY / 5}px) scale(${ratio})`
          activeGridImg.style.opacity = 0.4

          let activeGif = this.$refs.activeGif

          let posX = activeImgPos.x  // 逆运算位置和样式 需要中心 和首张运动后的中心重合
          let posY = activeImgPos.y
          let tempX = 33.1 + (309 / Math.pow(ratio, 5)) / 2  // 原始中心位置
          let tempY = 71.875 + (390 / Math.pow(ratio, 5)) / 2 // 原始中心位置
          let styleX = posY - tempY
          let styleY = posX - tempX
          activeGif.style.top = `${styleX}px`
          activeGif.style.left = `${styleY}px`

          activeGif.style.width = `${309 / Math.pow(ratio, 5)}px`
          activeGif.style.height = `${390 / Math.pow(ratio, 5)}px`

          activeGif.style.opacity = 0.4
          activeGif.style.display = 'block'
          setTimeout(() => {
            activeGif.style.top = 0
            activeGif.style.left = 0
            activeGif.style.width = '100%'
            activeGif.style.height = '100%'
          }, 50)
          activeGridImg.addEventListener('transitionend', () => {
            activeGridImg.style.display = 'none'
            activeGif.style.opacity = 1
          })
        }
      }, 1)
    }
  }
};
</script>

<style lang="scss" scoped>
.guide-wrap {
  width: 622px;
  height: 784px;

  img {
    width: 100%;
    height: 100%;
  }
}

.countError-wrap {
  width: 618px;
  height: 780px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prize-wrap {
  width: 618px;
  height: 780px;
  position: relative;
  transform-style: preserve-3d;
  perspective: 10000px;
  backface-visibility: hidden;

  .prize-content {
    background-size: 100% 100% !important;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: rotateY(180deg);
    backface-visibility: hidden;
    border-radius: 40px;
    background-color: transparent;

    &.prize-content-reverse {
      transform: rotateY(0);
    }
  }

  .ticket-code {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 200px;
  }

  .form {
    padding: 0 28px;
    position: absolute;
    bottom: 146px;
    box-sizing: border-box;
    // display: flex;
    // flex-direction: column;
    // justify-content: flex-end;
    width: 100%;
    box-sizing: border-box;

    .form-row {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      &:last-of-type {
        margin-bottom: 0;
      }

      &.address-row {
        align-items: flex-start;
      }
    }

    .form-icon {
      display: block;
      width: 12px;
      height: 20px;
      margin-right: 6px;
    }

    .form-label {
      font-size: 22px !important;
      color: #fff !important;
      width: auto;
    }

    .address-label {
      padding-top: 10px;
      display: flex;
      flex-direction: row;

      .form-icon {
        margin-top: 8px;
      }
    }

    .form-textarea,
    .form-input {
      flex: 1;
      font-size: 26px !important;
      box-sizing: border-box;
      padding: 8px 15px;
      border-radius: 0;
      background: none;
      color: #fff !important;
    }

    input::placeholder,
    textarea::placeholder {
      color: #FFE2CB !important;
      font-size: 26px !important;
    }

    .form-input {
      // height: 48px;
      // line-height: 28px;
      border-bottom: 1px dotted #fff !important;
    }

    .form-textarea {
      height: 98px;
      border: 1px dotted #fff !important;
    }
  }

  .btn {
    width: 328px;
    height: 76px;
    display: inline-block;
    /*no*/
    position: absolute;
    bottom: 52px;
    left: 50%;
    transform: translateX(-50%);
  }

  .prize-area {
    width: 100%;
    height: 100%;
  }
}

.energy-wrap,
.swiper-wrap {
  background-size: 100% 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.energy-wrap {
  height: 88px;
  letter-spacing: 2px;
}

.swiper-wrap {
  height: 78px;
  padding: 8px 0;
  overflow: hidden;

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      width: 100%;
      text-align: center;
      padding: 0 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.wantgrid-wrap {
  height: 590px;
  box-sizing: border-box;
  font-size: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 100% 100% !important;
  background-repeat: repeat;

  .grid-content {
    width: 680px;
    height: 560px;
    background-size: 100% 100% !important;
    background-repeat: no-repeat;
    position: relative;
  }

  .grid-item,
  .grid-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .grid-img {
    z-index: 2;
  }

  .grid-active {
    position: absolute;
    z-index: 3;
    transition: all 0.05s linear;

    &.active-0 {
      width: 246px;
      height: 256px;
      top: 76px;
      left: 4px;
    }

    &.active-1 {
      width: 372px;
      height: 230px;
      left: 22px;
      bottom: 44px;
    }

    &.active-2 {
      width: 364px;
      height: 270px;
      right: 26px;
      bottom: -2px;
    }

    &.active-3 {
      width: 312px;
      height: 248px;
      right: 44px;
      bottom: 140px;
    }

    &.active-4 {
      width: 330px;
      height: 236px;
      top: 0;
      right: 4px;
    }

    &.active-5 {
      width: 232px;
      height: 282px;
      top: 80px;
      left: 172px;
    }
  }
}

.grid-btn-wrap {
  height: 200px;
  font-size: 0;
  position: relative;
  background-color: #D5300E;
  background-repeat: no-repeat;
  background-size: 100% 100% !important;

  .btn {
    width: 400px;
    height: 120px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
  }
}

.rule-wrap {

  .header,
  .footer {
    width: 100%;

    // height: 80px;
    img {
      width: 100%;
    }
  }

  .content {
    height: 480px;
    position: relative;

    .hot-area {
      width: 660px;
      height: 220px;
      position: absolute;
      left: 50%;
      display: flex;
      transform: translateX(-50%);

      div {
        flex: 1;
      }
    }
  }

  img {
    height: 100%;
  }
}

.reward-wrap {
  box-sizing: border-box;

  .header {
    width: 100%;

    img {
      width: 100%;
    }

    // height: 80px;
  }

  .active {
    max-height: 3.5 * 154px;
    overflow-y: auto;
  }

  .content {
    background-position: 0 0;
    background-size: 100% auto;
    background-repeat: repeat-y;

    img {
      width: 100%;
      // height: 154px;
      display: block;
    }
  }

  .footer {
    width: 100%;

    img {
      width: 100%;
    }
  }
}

.content-wrap {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate3d(-50%, -50%, 0);

  .active-gif-wrap {
    transform-style: preserve-3d;
    perspective: 10000px;
    width: 618px;
    height: 780px;
    position: relative;
  }

  .active-gif {
    position: absolute;
    backface-visibility: hidden;
    display: none;
    transition-property: width, height, left, top;
    transition-timing-function: linear;
    transition-duration: 0.25s;
  }

  .line {
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 90px;
    display: flex;
    flex-direction: column;

    span {
      width: 4px;
      height: 10px;
      margin-top: 7px;
      background: #fff;
    }
  }

  .close-icon {
    position: absolute;
    width: 80px;
    height: 80px;
    bottom: -84px;
    left: 50%;
    color: #fff;
    transform: translateX(-50%);
  }
}

.rotateTransition {
  animation: rotateTransition 1000ms ease-in;
}

@keyframes rotateTransition {
  0% {
    transform: rotateY(0);
  }

  100% {
    transform: rotateY(180deg);
  }
}

.rotateTransitionReverse {
  animation: rotateTransitionReverse 1000ms ease-in;
}

@keyframes rotateTransitionReverse {
  0% {
    transform: rotateY(180deg);
  }

  100% {
    transform: rotateY(0);
  }
}
</style>
